// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-row-button {
    align-items: right;
    background-color: transparent;
    color: rgb(50, 83, 220);
    border-radius: 32px;
    padding: 10px;
    border: 1px solid rgb(103, 114, 132);
    cursor: pointer;
    float: left;
    font-weight: bold;
    font-size: 14px;
    margin: 17px 0px;
}

.spacing {
    margin: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/components/assets/CreateSolution.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,oCAAoC;IACpC,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".add-row-button {\n    align-items: right;\n    background-color: transparent;\n    color: rgb(50, 83, 220);\n    border-radius: 32px;\n    padding: 10px;\n    border: 1px solid rgb(103, 114, 132);\n    cursor: pointer;\n    float: left;\n    font-weight: bold;\n    font-size: 14px;\n    margin: 17px 0px;\n}\n\n.spacing {\n    margin: 2rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
